import { useCallback, useState, useEffect } from 'react';
import { debounce } from 'lodash';
const useDebounceLocalData = (data, config) => {
    const { time = 300, debounceConfig = {
        leading: true,
        trailing: true,
    }, exception = () => false, } = config || {};
    const [localContent, setLocalContent] = useState(data);
    const debouceSetLocalContent = useCallback(debounce(data => setLocalContent(data), time, debounceConfig), []);
    useEffect(() => {
        if (exception(data)) {
            setLocalContent(data);
            debouceSetLocalContent.cancel();
        }
        else {
            debouceSetLocalContent(data);
        }
    }, [data]);
    return localContent;
};
export default useDebounceLocalData;
